module.exports = __webpack_public_path__ + "img/unityassetbundle.147e3dea.png";